const HomeAppView = () =>
  // @ts-ignore
  import(/*webpackChunkName: "HomeAppView"*/ "@/views/app/HomeApp.vue");

export default {
  path: "",
  name: "home",
  alias: ["index.html", "notfound"],
  component: HomeAppView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
  },
};
